import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import PublicationLinks from "../../Publications/components/PublicationLinks";
import { createTableHeader } from "../helpers";

const guidelinesTableHeaders = [
  {
    title: "Guideline",
    class: "tw-text-left tw-w-1/5",
    key: "1",
  },
  {
    title: "Drugs",
    class: "tw-text-left",
    key: "2",
  },
  {
    title: "Recommended",
    class: "tw-text-center",
    key: "3",
  },
  {
    title: "Publications",
    class: "tw-text-center",
    key: "4",
  },
  {
    title: "Summary",
    class: "tw-text-center tw-w-1/2",
    key: "5",
  },
];

const getGuidelinesRow = (item) => {
  const rows = [];
  if (item.chemical_relations && item.chemical_relations.length > 0) {
    const chemicalRelationsLength = item.chemical_relations.length;
    item.chemical_relations.forEach((i, j) => {
      const row = (
        <tr
          className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
          key={i.key}
        >
          {j === 0 && (
            <td
              className="tw-text-left tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.guidelineUrl ? (
                <a href={getVarsoUrl(item.guidelineUrl)} target="_blank">
                  {item.name || "-"}
                </a>
              ) : (
                item.name || "-"
              )}
            </td>
          )}
          <td className="tw-text-left tw-p-2.5">
            {i.chemicalUrl ? (
              <a href={getVarsoUrl(i.chemicalUrl)} target="_blank">
                {i.name || "-"}
              </a>
            ) : (
              i.name || "-"
            )}
          </td>
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.recommended || "-"}
            </td>
          )}
          {j === 0 && (
            <td
              className="tw-text-center tw-p-2.5"
              rowSpan={chemicalRelationsLength}
            >
              {item.pub_med_references ? (
                <PublicationLinks limit={10} ids={item.pub_med_references} />
              ) : (
                "-"
              )}
            </td>
          )}
          {j === 0 && (
            <td className="tw-p-2.5 tw-w-1/2" rowSpan={chemicalRelationsLength}>
              {item.summary || "-"}
            </td>
          )}
        </tr>
      );
      rows.push(row);
    });
  }
  return rows;
};

const createTableRows = (items) => {
  const rows = [];
  items.forEach((item) => {
    rows.push(getGuidelinesRow(item));
  });
  return rows;
};

export const getGuidelinesTable = (items) => {
  if (Array.isArray(items) && items.length !== 0) {
    const rows = createTableRows(items);
    const result = (
      <table className="tw-w-full tw-border-collapse tw-border-t tw-border-solid tw-border-gray-200 tw-break-words tw-font-saphetor">
        {createTableHeader(guidelinesTableHeaders)}
        <Expander showMore="10" columns="5" component="tbody">
          {rows}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
